module.exports = __webpack_public_path__ + "static/media/Logo.928dd53a.svg";